<avi-main-header-user-menu
    [username]="username$ | async"
    [fullName]="fullName$ | async"
    [email]="email$ | async"
    [lastLogin]="lastLogin$ | async"
    [customerPortalUrl]="customerPortalUrl$ | async"
></avi-main-header-user-menu>
